import * as React from "react"
import {PlaceNicknameLabel} from "./PlaceNicknameLabel"
import {PlaceIcon} from "./PlaceIcon"
import {PlaceCategory, PlaceType} from "../graphql/queries"
import {PlaceNickname} from "../model/places/PlaceTypes"

interface Props {
  nickname: PlaceNickname | null
  type: PlaceType
  category: PlaceCategory | null
  pointing: false | "right"
}

export function PlaceSign({nickname, type, category, pointing}: Props) {
  return nickname ? (
    <PlaceNicknameLabel nickname={nickname.label} pointing={pointing} />
  ) : (
    <PlaceIcon type={type} category={category} />
  )
}



// WEBPACK FOOTER //
// ./src/components/PlaceSign.tsx